<template>
  <div class="trendChart c3-custom-chart" :id="chartId"></div>
</template>

<script>
  import c3 from 'c3';
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';

  export default {
    name: 'TrendChart',
    data() {
      return {
        chartId: `trendChart`,
        fields: [],
      };
    },
    computed: {
      ...mapGetters('allergyKpis', [
        'curYear',
        'prevYear',
        'benchmarkYear',
        'month',
        'year',
        'yearStart',
      ]),
      chartIdString() {
        return `#${this.chartId}`;
      },
      longestDataSetSize() {
        return lodash.max([this.curYear.length, this.prevYear.length]);
      },
      monthArray() {
        return lodash.map([...Array(12)], (month, index) => this.getCurrentYearName(index + 1) + '-' + this.getMonthNumber(index + 1) + '-01');
      },
      actualValueRaw() {
        return lodash.map(this.curYear, (month) => {
          return lodash.reduce(this.fields, (sum, field) => {
            return sum + parseInt(month[field])
          }, 0);
        });
      },
      benchmarkValueRaw() {
        return lodash.map(this.benchmarkYear, (month) => {
          return lodash.reduce(this.fields, (sum, field) => {
            return sum + parseInt(month[field])
          }, 0);
        });
      },
      previousValueRaw() {
        return lodash.map(this.prevYear, (month) => {
          return lodash.reduce(this.fields, (sum, field) => {
            return sum + parseInt(month[field])
          }, 0);
        });
      },
      chartData () {
        return {
          Current: lodash.map(this.monthArray, (value, index) => this.actualValueRaw[index] || '-'),
          Prior: lodash.map(this.monthArray, (value, index) => this.previousValueRaw[index] || '-'),
          Benchmark: lodash.map(this.monthArray, (value, index) => this.benchmarkValueRaw[index] || '-'),
          months: this.monthArray,
        };
      },
      chartDataJson () {
        return this.chartData;
      },
    },
    watch: {
      curYear() {
        this.drawChart();
      },
    },
    mounted() {
      window.addEventListener('resize', this.drawChart());
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.drawChart());
    },
    methods: {
      getCurrentYearName(month) {
        return (month) + this.yearStart > 13 ? parseInt(this.year) + 1 : parseInt(this.year);
      },
      getMonthNumber(month, pad = true) {
        let monthString = ((month + (this.yearStart - 2)) % 12) + 1;
        return (pad == true) ? monthString.toString().padStart(2, '0') : monthString;
      },
      drawChart() {
        c3.generate({
          bindto: this.chartIdString,
          size: { height: 300 },
          data: {
            json: this.chartDataJson,
            type: 'bar',
            x: 'months',
            types: {
              'Current': 'bar',
              'Prior': 'bar',
              'Benchmark': 'line'
            },
            colors: {
              'Current': '#824a9e',
              'Prior': '#39c2c9',
              'Benchmark': '#f6682f',
            },
          },
          axis: {
            x: {
              type: 'timeseries',
              tick: {
                format: '%b %y',
                culling: false
              }
            },
            y : {
              tick: {
                format: d3.format(",.0f")
              }
            },
          },
          grid: {
            y: { show: true },
          },
          tooltip: {
            format: { value: d3.format(",.0f") },
          },
        });
      },
    },
  };
</script>
